export default {
    general: {
        add: 'Dodaj',
        edit: 'Uredi',
        save: 'Shrani',
        cancel: 'Prekliči',
        delete: 'Izbriši',
        actions: 'Dejanja',
        search: 'Iskanje',
        active: 'Aktiven',
        yes: 'Da',
        no: 'Ne',
        empty: 'Ni zapisov',
        loading: 'Nalaganje…',
    },
    auth: {
        sign_in: 'Prijava',
        username: 'Uporabniško ime',
        password: 'Geslo',
        welcome: 'TimeTerminal Admin',
        subtitle: 'Prijavite se za upravljanje terminalov',
        invalid_credentials: 'Napačno uporabniško ime ali geslo',
    },
    nav: {
        users: 'Uporabniki',
        projects: 'Projekti',
        devices: 'Naprave',
        module_types: 'Tipi modulov',
        managed_play: 'Trgovina z aplikacijami',
        data: 'Podatki',
        logout: 'Odjava',
        coming_soon: 'Kmalu na voljo',
        audit_card_reads: 'Odčitki kartic',
        audit_exchanges: 'ERP izmenjave',
        audit_events: 'Dogodki naprave',
    },
    user: {
        users: 'Uporabniki',
        user: 'Uporabnik',
        add: 'Dodaj uporabnika',
        edit: 'Uredi uporabnika',
        username: 'Uporabniško ime',
        email: 'E-pošta',
        password: 'Geslo',
        new_password: 'Novo geslo (pustite prazno za ohranitev)',
        role: 'Vloga',
        projects: 'Projekti',
        active: 'Aktiven',
        last_login: 'Zadnja prijava',
        confirm_delete: 'Izbrišem tega uporabnika?',
    },
    project: {
        projects: 'Projekti',
        project: 'Projekt',
        add: 'Dodaj projekt',
        edit: 'Uredi projekt',
        name: 'Naziv',
        description: 'Opis',
        active: 'Aktiven',
        confirm_delete: 'Izbrišem ta projekt?',
    },
    device: {
        name: 'Naziv',
        project: 'Projekt',
        module_type: 'Modul',
        state: 'Stanje',
        config: 'Nastavitve',
        add: 'Dodaj napravo',
        provision: 'Pripravi',
        overview: 'Pregled',
        provisioning: 'Priprava',
        diagnostics: {
            tab:               'Diagnostika',
            snapshot:          'Trenutno stanje',
            battery:           'Baterija',
            charging:          'Se polni',
            not_charging:      'Se ne polni',
            network:           'Omrežje',
            online:            'Povezano',
            not_online:        'Nepovezano',
            storage:           'Prostor',
            storage_format:    '{free} GB prosto od {total} GB',
            app_version:       'Različica aplikacije',
            queue_depth:       'Čakalna vrsta',
            last_seen:         'Nazadnje videno',
            heartbeat_at:      'Zadnji srčni utrip',
            amp_status_at:     'Zadnji status AMP',
            history:           'Zgodovina',
            history_collected: 'Zbrano',
            history_source:    'Vir',
            history_battery:   'Baterija',
            history_network:   'Omrežje',
            history_queue:     'Čakalna vrsta',
            source_heartbeat:  'Srčni utrip',
            source_amp_status: 'Status AMP',
            no_data:           'Ni diagnostičnih podatkov',
            never:             'Nikoli',
        },
        desired_config: 'Želena različica nastavitev',
        reported_config: 'Poročana različica nastavitev',
        config_status: 'Stanje nastavitev',
        config_up_to_date: 'Posodobljeno',
        config_restart_pending: 'Čaka na ponovni zagon',
        restart: {
            button:  'Ponovno zaženi aplikacijo',
            confirm: 'Ponovno zaženem aplikacijo na tej napravi za uveljavitev najnovejših nastavitev? Naprava se vrne na začetni zaslon.',
            header:  'Ponovni zagon aplikacije',
            success: 'Zahteva za ponovni zagon poslana — naprava bo kmalu uveljavila nastavitve',
            error:   'Napaka pri zahtevi za ponovni zagon',
        },
        decommission: {
            button:  'Razgradi',
            confirm: 'Ste prepričani, da želite razgraditi to napravo? Tega dejanja ni mogoče razveljaviti.',
            header:  'Razgradnja naprave',
            success: 'Naprava je bila uspešno razgrajena',
            error:   'Napaka pri razgradnji naprave',
        },
    },
    device_state: {
        created: 'Ustvarjeno',
        enrolling: 'V vpisu',
        enrolled: 'Vpisano',
        active: 'Aktivno',
        offline: 'Nepovezano',
        decommissioned: 'Razgrajeno',
    },
    provision: {
        title: 'Priprava naprave',
        scan_instructions: 'Tovarniško ponastavite tablico, nato skenirajte to QR kodo za vpis.',
        expires_in: 'Poteče čez',
        waiting: 'Čakanje na vpis naprave…',
        enrolled: 'Naprava vpisana',
        not_configured: 'Priprava na strežniku ni nastavljena (Android Management API).',
        dev_connect: 'Razvijalska povezava (debug različice)',
        dev_connect_help: 'Skenirajte to v zaslonu Razvijalska povezava v aplikaciji za povezavo brez AMAPI.',
    },
    config: {
        title: 'Nastavitve naprave',
        version: 'Različica',
        override: 'Prezri preverjanje različice aplikacije',
        upload_legacy: 'Naloži obstoječo konfiguracijo',
        app_version_gate: 'Blokirano: aplikacija na napravi je starejša od zahtevane sheme. Vklopite prezrtje za shranjevanje.',
        imported: 'Stara konfiguracija uvožena — preglejte in shranite',
        import_failed: 'Uvoz naložene konfiguracije ni uspel',
        unsupported_module: 'Za tip modula »{module}« ni urejevalnika konfiguracije.',
    },
    managed_play: {
        title: 'Trgovina z aplikacijami',
        subtitle: 'Objavite in upravljajte aplikacijo terminala v upravljani Google Play trgovini vaše organizacije.',
        token_failed: 'Upravljane Google Play ni bilo mogoče odpreti (zagotavljanje je morda onemogočeno).',
        gapi_failed: 'Google API-jev ni bilo mogoče naložiti — preverite omrežje in zaviralce oglasov.',
        update_title: 'Različica aplikacije',
        update_help: 'Uveljavite najnižjo različico aplikacije na vseh napravah. Pustite čas prazen za takojšnjo uveljavitev ali izberite čas za načrtovanje.',
        current_version: 'Uveljavljena različica',
        version_code: 'Ciljna koda različice',
        apply_at: 'Uveljavi ob',
        now: 'Takoj',
        scheduled: 'Načrtovano',
        update_applied: 'Različica aplikacije posodobljena.',
        update_failed: 'Različice aplikacije ni bilo mogoče posodobiti.',
    },
    probit: {
        title: 'ProBit nastavitve',
        erp: 'ERP povezava',
        server_url: 'URL strežnika',
        event_path: 'Pot dogodka',
        info_path: 'Pot podatkov delavca',
        worker_plan_path: 'Pot plana dela',
        company_id: 'ID podjetja',
        identifiers: 'Identifikatorji',
        terminal_id: 'ID terminala',
        default_location_id: 'Privzeti ID lokacije',
        heimdall: 'Heimdall (nadzor vrat)',
        heimdall_url: 'Heimdall URL',
        heimdall_api_key: 'Heimdall API ključ',
        ui: 'Videz',
        background_color: 'Barva ozadja',
        current_plan_background_color: 'Barva trenutnega plana',
        next_plan_background_color: 'Barva naslednjega plana',
        other_cost_center_background_color: 'Barva drugih stroškovnih mest',
        behavior: 'Obnašanje',
        selection_type: 'Način izbire',
        selection_type_a: 'Način A',
        selection_type_b: 'Način B',
        info_on_every_action: 'Prikaži info ob vsakem dogodku',
        show_nfc_sign: 'Prikaži NFC poziv',
        nfc_sign_position: 'Položaj NFC poziva (četrtina zaslona)',
        nfc_pos_top_left: 'Zgoraj levo',
        nfc_pos_top_right: 'Zgoraj desno',
        nfc_pos_bottom_left: 'Spodaj levo',
        nfc_pos_bottom_right: 'Spodaj desno',
        timeouts: 'Časovne omejitve (ms)',
        event_clear_ms: 'Počisti dogodek',
        info_clear_ms: 'Počisti info',
        cost_center_auto_back_ms: 'Samodejni povratek stroškovnega mesta',
        actions: 'Dejanja',
        action_title: 'Naziv',
        action_event_id: 'ID dogodka',
        action_color: 'Barva',
        action_icon_color: 'Barva ikone',
        action_icon: 'Ikona',
        action_info_button: 'Info gumb',
        action_heimdall_terminal: 'Heimdall terminal',
        action_cost_center_selection: 'Izbira stroškovnega mesta',
        action_location_id: 'ID lokacije',
    },
    role: {
        admin: 'Administrator',
        user: 'Uporabnik',
    },
    audit: {
        card_reads: 'Odčitki kartic',
        exchanges: 'ERP izmenjave',
        events: 'Dogodki naprave',
        outcome: 'Izid',
        outcome_idle_scan: 'Nedejavno skeniranje',
        outcome_info: 'Info',
        outcome_action: 'Dejanje',
        outcome_failed: 'Napaka',
        card_uid: 'UID kartice',
        occurred_at: 'Čas',
        device: 'Naprava',
        result_status: 'Rezultat',
        replayed: 'Ponovljeno',
        action_event_id: 'Dejanje',
        operation: 'Operacija',
        request_method: 'Metoda',
        request_url: 'URL',
        response_status: 'Status',
        latency_ms: 'Zakasnitev (ms)',
        event_type: 'Tip dogodka',
        from: 'Od',
        to: 'Do',
        correlation: 'Veriga poizvedbe',
        exchange_detail: 'Podrobnosti izmenjave',
        request_headers: 'Glava zahteve',
        response_headers: 'Glava odgovora',
        request_body: 'Telo zahteve',
        response_body: 'Telo odgovora',
        empty_body: '(prazno)',
        filter_project: 'Projekt',
        filter_device: 'Naprava',
        filter_outcome: 'Izid',
        filter_from: 'Datum od',
        filter_to: 'Datum do',
        all_projects: 'Vsi projekti',
        all_devices: 'Vse naprave',
        all_outcomes: 'Vsi izidi',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data: 'Neveljavni podatki',
        not_found: 'Ni najdeno',
        unauthorized: 'Nepooblaščen dostop',
        conflict: 'Že obstaja',
        on_add: 'Napaka pri dodajanju',
        on_edit: 'Napaka pri posodabljanju',
        on_delete: 'Napaka pri brisanju',
        load_failed: 'Napaka pri nalaganju podatkov',
    },
    success: {
        add: 'Uspešno dodano',
        edit: 'Uspešno posodobljeno',
        delete: 'Uspešno izbrisano',
    },
}
